export default __webpack_public_path__ + "static/media/2.6a4456b6.svg";